(function () {
  "use strict";
  var KEY = "ml_ws_gate_ok";

  function initGate() {
    var wrap = document.getElementById("ml-ws-gate-wrap");
    var landing = document.getElementById("ml-ws-landing");
    if (!wrap) return;

    var phrase = (wrap.getAttribute("data-phrase") || "").trim().toLowerCase();

    function unlock() {
      try { sessionStorage.setItem(KEY, "1"); } catch (e) {}
      wrap.hidden = true;
      if (landing) landing.hidden = false;
      window.scrollTo(0, 0);
    }

    /* Auto-unlock from an emailed link: /pages/wholesale-preview?key=<phrase>.
       Lets a buyer invitation open straight onto the range with no typing.
       The key is stripped from the address bar immediately so it is not left
       in history, in a shared screenshot, or in an outbound referrer. Other
       params (Klaviyo's _kx, any utm_*) are preserved. */
    var qs = null;
    try { qs = new URLSearchParams(window.location.search); } catch (e) {}
    var keyed = qs ? (qs.get("key") || "").trim().toLowerCase() : "";
    if (phrase && keyed && keyed === phrase) {
      try {
        qs.delete("key");
        var rest = qs.toString();
        history.replaceState(null, "", window.location.pathname + (rest ? "?" + rest : "") + window.location.hash);
      } catch (e) {}
      unlock();
      return;
    }

    var already = false;
    try { already = sessionStorage.getItem(KEY) === "1"; } catch (e) {}
    if (already) { unlock(); return; }

    var form = document.getElementById("ml-ws-gate-form");
    var input = document.getElementById("ml-ws-gate-password");
    var err = document.getElementById("ml-ws-gate-error");
    if (!form) return;

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var entered = (input.value || "").trim().toLowerCase();
      if (phrase && entered === phrase) {
        if (err) err.hidden = true;
        unlock();
      } else {
        if (err) err.hidden = false;
        input.focus();
        input.select();
      }
    });
  }

  function money(n) {
    return "$" + (Math.round(n * 100) / 100).toFixed(2);
  }

  /* PDP bundle tiles. The unit price is derived from the SELECTED VARIANT
     divided by the piece count, not from the product metafield — pouches
     price small and large differently on the same product. */
  function initTiles() {
    var picker = document.getElementById("ml-ws-picker");
    var idSel = document.getElementById("ml-ws-variant-id");
    if (!picker || !idSel) return;

    var fallbackPer = parseFloat(picker.getAttribute("data-per-piece") || "0") || 0;
    var mixEl = document.getElementById("ml-ws-mix");
    var ppEl = document.getElementById("ml-ws-pp");
    var calcEl = document.getElementById("ml-ws-calc");
    var totalEl = document.getElementById("ml-ws-total");
    var noteEl = document.getElementById("ml-ws-bundle-note");
    var groups = [].slice.call(picker.querySelectorAll(".ml-ws-tiles"));
    var hasXl = !!picker.querySelector("[data-x]");

    function chosenIn(group) {
      return group.querySelector(".ml-ws-tile.is-on") || group.querySelector(".ml-ws-tile");
    }

    function sync() {
      var vals = groups.map(function (g) {
        var t = chosenIn(g);
        return t ? t.getAttribute("data-val") : "";
      });
      var chosen = vals.join(" || ");

      var matched = null;
      [].slice.call(idSel.options).forEach(function (o) {
        if (o.getAttribute("data-opts") === chosen) matched = o;
      });

      var base = 0, xl = 0;
      groups.forEach(function (g) {
        var t = chosenIn(g);
        if (!t) return;
        if (t.hasAttribute("data-n")) base = parseInt(t.getAttribute("data-n"), 10) || 0;
        if (t.hasAttribute("data-x")) xl = parseInt(t.getAttribute("data-x"), 10) || 0;
      });
      var units = base + xl;

      if (mixEl) {
        if (hasXl && base) {
          var third = base / 3;
          mixEl.textContent = third + " S \u00b7 " + third + " M \u00b7 " + third + " L" +
            (xl ? " \u00b7 " + xl + " XL" : "");
        } else {
          mixEl.textContent = units ? units + " pieces" : "";
        }
      }

      var total = matched ? parseFloat(matched.getAttribute("data-pnum")) : NaN;
      var per = (!isNaN(total) && units) ? total / units : fallbackPer;
      if (isNaN(total) && units && fallbackPer) total = units * fallbackPer;

      if (ppEl) ppEl.textContent = per ? money(per) : "";
      if (calcEl) calcEl.textContent = (units && per) ? units + " pieces \u00d7 " + money(per) : "";
      if (totalEl) totalEl.textContent = !isNaN(total) ? money(total) : "";

      if (matched) {
        idSel.value = matched.value;
        if (noteEl) noteEl.textContent = "";
      } else if (noteEl) {
        noteEl.textContent = "That combination is not available \u2014 email us and we will quote it.";
      }
    }

    picker.addEventListener("click", function (e) {
      var tile = e.target.closest && e.target.closest(".ml-ws-tile");
      if (!tile) return;
      var group = tile.closest(".ml-ws-tiles");
      if (!group) return;
      [].slice.call(group.querySelectorAll(".ml-ws-tile")).forEach(function (t) {
        var on = t === tile;
        t.classList.toggle("is-on", on);
        t.setAttribute("aria-checked", on ? "true" : "false");
      });
      sync();
    });

    sync();
  }

  /* Add to order WITHOUT leaving the page, so a buyer can add a small run and
     a large run of the same pouch back to back. Falls back to a normal form
     POST if fetch fails or JS is off. */
  function initAddToCart() {
    var btn = document.querySelector(".ml-ws-add-to-cart");
    if (!btn) return;
    var form = btn.closest("form");
    if (!form) return;

    var note = document.createElement("div");
    note.className = "ml-ws-added";
    note.hidden = true;
    form.parentNode.insertBefore(note, form.nextSibling);

    function setCount(n) {
      var link = document.querySelector(".ml-ws-cartlink");
      if (!link) return;
      link.innerHTML = n > 0 ? "Your order <b>(" + n + ")</b>" : "Your order";
    }

    form.addEventListener("submit", function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Adding\u2026";

      fetch("/cart/add.js", { method: "POST", body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
        .then(function (line) {
          return fetch("/cart.js").then(function (r) { return r.json(); })
            .then(function (cart) { return { line: line, cart: cart }; });
        })
        .then(function (d) {
          setCount(d.cart.item_count);
          var bundle = (d.line.variant_title || "").replace(" / ", " \u00b7 ");
          note.innerHTML = "Added " + (bundle ? "<b>" + bundle + "</b> " : "") +
            "to your order. <a href=\"/cart?view=wholesale\">Review and place it</a>, " +
            "or keep adding \u2014 you can order more than one size.";
          note.hidden = false;
          btn.disabled = false;
          btn.textContent = label;
        })
        .catch(function () { form.submit(); });
    });
  }

  /* Deposit route. Post the basket to Shopify's contact form IN THE BACKGROUND
     so the buyer is never sent to checkout — checkout is the other route, and
     landing there after asking to be invoiced is exactly the wrong outcome.
     On success: clear the cart and show the confirmation panel in place. */
  function initInvoiceForm() {
    var form = document.querySelector(".ml-ws-invoice-form");
    if (!form || !window.fetch) return;
    var btn = form.querySelector("button[type=submit]");

    form.addEventListener("submit", function (e) {
      if (!form.checkValidity()) return;
      e.preventDefault();
      var label = btn ? btn.textContent : "";
      if (btn) { btn.disabled = true; btn.textContent = "Sending\u2026"; }

      fetch("/contact", {
        method: "POST",
        body: new FormData(form),
        headers: { "Accept": "text/html" }
      })
        .then(function () { return fetch("/cart/clear.js", { method: "POST" }); })
        .then(function () {
          var sent = document.getElementById("ml-ws-cart-sent");
          var main = document.getElementById("ml-ws-cart-main");
          if (sent) sent.hidden = false;
          if (main) main.hidden = true;
          var link = document.querySelector(".ml-ws-cartlink");
          if (link) link.innerHTML = "Your order";
          window.scrollTo(0, 0);
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = label; }
          alert("That did not send. Please email hello@meandlia.com and we will invoice you directly.");
        });
    });
  }

  /* Fallback <select> control for products not on the bundle model. */
  function initSelects() {
    var idSel = document.getElementById("ml-ws-variant-id");
    var opts = [].slice.call(document.querySelectorAll(".ml-ws-optsel"));
    var noteEl = document.getElementById("ml-ws-bundle-note");
    if (!idSel || !opts.length) return;

    function sync() {
      var chosen = opts.map(function (s) { return s.value; }).join(" || ");
      var matched = null;
      [].slice.call(idSel.options).forEach(function (o) {
        if (o.getAttribute("data-opts") === chosen) matched = o;
      });
      if (matched) {
        idSel.value = matched.value;
        if (noteEl) noteEl.textContent = matched.getAttribute("data-price") || "";
      } else if (noteEl) {
        noteEl.textContent = "That combination is not available.";
      }
    }

    opts.forEach(function (s) { s.addEventListener("change", sync); });
    sync();
  }

  function initGallery() {
    var btn = document.getElementById("ml-ws-show-all");
    var extra = document.getElementById("ml-ws-grid-extra");
    if (btn && extra) {
      btn.addEventListener("click", function () {
        extra.hidden = false;
        btn.hidden = true;
      });
    }

    var box = document.getElementById("ml-ws-lightbox");
    var img = document.getElementById("ml-ws-lightbox-img");
    var close = document.getElementById("ml-ws-lightbox-close");
    if (!box || !img) return;

    document.addEventListener("click", function (e) {
      var item = e.target.closest && e.target.closest(".ml-ws-grid-item");
      if (!item) return;
      var src = item.querySelector("img");
      if (!src) return;
      img.src = src.src;
      img.alt = src.alt || "";
      box.hidden = false;
    });

    function hide() { box.hidden = true; }
    if (close) close.addEventListener("click", hide);
    box.addEventListener("click", function (e) { if (e.target === box) hide(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") hide(); });
  }

  function boot() {
    initGate(); initTiles(); initAddToCart(); initInvoiceForm(); initSelects(); initGallery();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }
})();
